"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityFeed = exports.EntityFeedDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_app_section_definition_1 = require("../../hooks/use-app-section-definition");
var use_lang_1 = require("../../hooks/use-lang");
var platform_activity_entry_card_1 = require("./platform-activity-entry-card");
var icon_1 = require("../elements/icon");
exports.EntityFeedDefaultProps = {
  items: []
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n  "], ["\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n  "])), theme_1.theme.MAX('content-width')),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    box-sizing: border-box;\n    position: relative;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    width: 100%;\n    box-sizing: border-box;\n    position: relative;\n    flex-direction: column;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var MARGIN_UNITS = 8;
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    box-sizing: border-box;\n  "], ["\n    box-sizing: border-box;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 100%;\n    ", "\n  "], ["\n    width: 100%;\n    ", "\n  "])), function (props) {
    return props.hasAside && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      width: calc(66.666% - ", ");\n      margin-right: ", ";\n    "], ["\n      width: calc(66.666% - ", ");\n      margin-right: ", ";\n    "])), theme_1.theme.UNIT(MARGIN_UNITS), theme_1.theme.UNIT(MARGIN_UNITS));
  })
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: calc(33.3333%);\n    position: sticky;\n    top: 0;\n  "], ["\n    width: calc(33.3333%);\n    position: sticky;\n    top: 0;\n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-weight: 300;\n    font-size: ", ";\n    color: ", ";\n    margin: 0;\n    font-weight: 500;\n    padding: ", " ", ";\n    display: flex;\n    align-items: center;\n\n    b {\n      font-weight: 300;\n      color: ", ";\n    }\n\n  "], ["\n    font-weight: 300;\n    font-size: ", ";\n    color: ", ";\n    margin: 0;\n    font-weight: 500;\n    padding: ", " ", ";\n    display: flex;\n    align-items: center;\n\n    b {\n      font-weight: 300;\n      color: ", ";\n    }\n\n  "])), theme_1.theme.FONT_SIZE(15), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(2), theme_1.theme.UNIT(3), theme_1.theme.COLOR('dark'))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(7))
});
var TitleIconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Main: styled_components_1.default.main(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Items: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: (0, styled_components_1.default)(platform_activity_entry_card_1.PlatformActivityEntryCard)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Aside: styled_components_1.default.aside(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Title: styled_components_1.default.h1(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  TitleIcon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), TitleIconStyles)
};
var EntityFeed = function (props) {
  var className = props.className,
    items = props.items;
  var appSection = (0, use_app_section_definition_1.useAppSectionDefinition)().appSection;
  var t = (0, use_lang_1.useLang)();
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Main, {
    hasAside: false
  }, react_1.default.createElement(My.Items, null, items.map(function (item, index) {
    return react_1.default.createElement(My.Item, {
      showIndicators: true,
      showConversation: index === 0,
      key: "".concat(index, "-").concat(item.id),
      entry: item
    });
  })))));
};
exports.EntityFeed = EntityFeed;
exports.EntityFeed.defaultProps = exports.EntityFeedDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;